var u = (t) => t.ownerDocument.defaultView || window;
function c(t, n) {
  const { type: r = "HTMLInputElement", property: o = "value" } = n, e = u(t)[r].prototype;
  return Object.getOwnPropertyDescriptor(e, o) ?? {};
}
function i(t, n, r = {}) {
  var e;
  (e = c(t, r).set) == null || e.call(t, n), t.setAttribute("value", n);
}
function p(t, n) {
  const { value: r, bubbles: o = !0 } = n;
  if (!t) return;
  const e = u(t);
  t instanceof e.HTMLInputElement && (i(t, `${r}`), t.dispatchEvent(new e.Event("input", { bubbles: o })));
}
export {
  p as dispatchInputValueEvent,
  i as setElementValue
};
